var _Path, _Path2, _Path3, _G, _G2, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, G, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgSlots = function SvgSlots(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#713000",
    d: "M30.375 5.063H6.188a4.5 4.5 0 0 0-4.5 4.5v18.562a4.5 4.5 0 0 0 4.5 4.5h24.187a4.5 4.5 0 0 0 4.5-4.5V9.563a4.5 4.5 0 0 0-4.5-4.5"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#slots_svg__a)",
    stroke: "#FFF2A3",
    strokeWidth: 0.844,
    d: "M29.25 3.375H5.625a4.5 4.5 0 0 0-4.5 4.5v18a4.5 4.5 0 0 0 4.5 4.5H29.25a4.5 4.5 0 0 0 4.5-4.5v-18a4.5 4.5 0 0 0-4.5-4.5Z"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#6D2309",
    d: "M28.688 6.75h-22.5A2.25 2.25 0 0 0 3.938 9v15.75A2.25 2.25 0 0 0 6.188 27h22.5a2.25 2.25 0 0 0 2.25-2.25V9a2.25 2.25 0 0 0-2.25-2.25"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#E49A16",
    strokeWidth: 0.563
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "url(#slots_svg__b)",
    d: "M11.813 7.875H6.187c-.62 0-1.125.504-1.125 1.125v15.75c0 .621.504 1.125 1.125 1.125h5.626c.62 0 1.124-.504 1.124-1.125V9c0-.621-.503-1.125-1.124-1.125Z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "url(#slots_svg__c)",
    d: "M20.25 7.875h-5.625c-.621 0-1.125.504-1.125 1.125v15.75c0 .621.504 1.125 1.125 1.125h5.625c.621 0 1.125-.504 1.125-1.125V9c0-.621-.504-1.125-1.125-1.125Z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "url(#slots_svg__d)",
    d: "M28.688 7.875h-5.625c-.622 0-1.125.504-1.125 1.125v15.75c0 .621.503 1.125 1.125 1.125h5.625c.62 0 1.125-.504 1.125-1.125V9c0-.621-.504-1.125-1.125-1.125Z"
  }))), _G2 || (_G2 = /*#__PURE__*/React.createElement(G, {
    fill: "#A91B09",
    stroke: "#742000",
    strokeWidth: 0.281
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M6.188 11.813h5.625v2.812L9 22.5H6.75l2.813-7.875H6.187zM14.625 11.813h5.625v2.812L17.438 22.5h-2.25L18 14.625h-3.375zM23.063 11.813h5.625v2.812L25.875 22.5h-2.25l2.813-7.875h-3.375z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "slots_svg__a",
    x1: 1.125,
    x2: 8.008,
    y1: 3.375,
    y2: 31.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF8BD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.38,
    stopColor: "#FFE16A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.62,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#B86700"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "slots_svg__b",
    x1: 5.063,
    x2: 5.063,
    y1: 7.875,
    y2: 25.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF5B5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFCC3E"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "slots_svg__c",
    x1: 13.5,
    x2: 13.5,
    y1: 7.875,
    y2: 25.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF5B5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFCC3E"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "slots_svg__d",
    x1: 21.938,
    x2: 21.938,
    y1: 7.875,
    y2: 25.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF5B5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFCC3E"
  })))));
};
export default SvgSlots;